import React, { Component } from 'react'
import ThemeManager from './ThemeManager';
import Drawer from 'react-drag-drawer';
import './Popupstyle.css';

export class PaymentForm extends Component {

    constructor(props){
        super(props);

        this.state = { info: props.info, canPay: true, openLoader: false };
    }


    toggleLoader = () => {
        this.setState({ openLoader: false })
     }


     goBack = () => {
        this.props.back();
     }
  

    payNow = (e) => {
        if(this.state.canPay){
            this.setState({ canPay: false});

            this.setState({ openLoader: true })
            this.props.pay();

        }
    }


    render() {

        let themeManager = ThemeManager.getInstance();
        const _selectionColor = themeManager.getSelectionColor();
        const _secondaryTextColor = themeManager.getSecondaryTextColor();
        const _buttonTextColor = themeManager.getButtonTextColor();
        
        return (
            <div>
                
                <div style={{ marginTop: '30px', color: 'rgb(198,210,25)', fontSize: '11px', fontWeight: 'bold'}}>
                Pagamento sicuro con Stripe
                </div>
                
                
                <div><div  style={{ marginTop: '5px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <p style={{ cursor: 'pointer',  fontWeight: 'bold', height: '40px', width: '250px', borderRadius: '8px', backgroundColor: _selectionColor, fontSize: '14px', 
            textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', color: _buttonTextColor, opacity: this.state.canPay ? '1.0' : '0.5'}}
            onClick={this.payNow}
            >

                    Paga ora</p>
                    </div>
                    </div>
                    {this.state.info.billing_require == '1' &&
                    <div  style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div onClick={this.goBack} style={{cursor: 'pointer', fontSize: '14px', color: _secondaryTextColor }}>annulla</div>
                    </div>
                    }

                    <Drawer
                    open={this.state.openLoader}
                        onRequestClose={this.toggleLoader}
                        modalElementClass="modal">
                            <div>
                    <div  style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{marginTop: '20px', fontSize: '14px', color: 'rgb(60,60,60)'}}>Stiamo elaborando <br />il tuo pagamento</div>
                    </div>
                   <div style={{ margin: '45px auto 0 auto', width: '42px', height: '42px', border: '4px solid rgba(60,60,60,0.12)', borderTopColor: _selectionColor, borderRadius: '50%', animation: 'spin 0.9s linear infinite' }} />
                   <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
                   <div  style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{marginTop: '30px', fontSize: '14px', color: 'rgb(60,60,60)'}}>Attendi qualche secondo</div>
                    </div>
                   
                    </div>
                    </Drawer>
            </div>
        )
    }
}

export default PaymentForm
